<div class="avatar-list" requireFullElement="true" (finderInViewport)="animateAvatars()">
    <finder-component-header
        [data]="title"
    ></finder-component-header>
    <div class="avatars">
        <finder-avatar
            *ngFor="let avatar of avatarList"
            class="character-avatar"
            [title]="avatar.name"
            [animateAvatar]="avatar.animate"
            [avatar]="avatar.image">
        </finder-avatar>
    </div>
</div>
